import React from "react";
import { Helmet } from "react-helmet-async";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import WhiteNavbar from "components/Navbars/WhiteNavbar";
import Footer from "components/Footers/Footer";
import { CEREZ_TEXT } from "content/legal/CerezPolitikasıText";

const CerezPolitikasi = () => {
  React.useEffect(() => {
    document.body.classList.add("contact-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    return function cleanup() {
      document.body.classList.remove("contact-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const lines = CEREZ_TEXT.trim().split("\n");

  return (
    <>
      <Helmet>
        <title>Çerez Politikası | Ekşioglu Hukuk</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Çerezler ve benzeri teknolojilere ilişkin bilgilendirme."
          data-rh="true"
        />
        <link
          rel="canonical"
          href="https://www.eksiogluhukukofisi.com/cerez-politikasi"
        />
      </Helmet>

      <div>
        <WhiteNavbar />

        <Container>
          <div className="section">
            <Row>
              <Col className="ml-auto mr-auto text-center" md="12">
                <div className="my-6">
                  <h1
                    className="font-weight-bold font-sans"
                    style={{
                      background: "linear-gradient(135deg, #0F172A, #333333)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontSize: "2.2em",
                      marginBottom: "18px",
                    }}
                  >
                    ÇEREZ POLİTİKASI VE AYDINLATMA METNİ
                  </h1>
                </div>
              </Col>
            </Row>

            <Row>
              <Col className="ml-auto mr-auto" md="12">
                <Card className="bg-white rounded-lg shadow-lg overflow-hidden font-sans">
                  <CardBody className="p-4">
                    <div
                      style={{
                        whiteSpace: "pre-wrap",
                        lineHeight: 1.75,
                        color: "#0F172A",
                      }}
                    >
                      {lines.map((rawLine, idx) => {
                        const line = (rawLine || "").replace(/\r/g, "");
                        const trimmed = line.trim();

                        if (!trimmed) {
                          return <div key={idx} style={{ height: 10 }} />;
                        }

                        // ====== TESPİT ======
                        const isMainTitle =
                          trimmed === "ÇEREZ POLİTİKASI VE AYDINLATMA METNİ" ||
                          trimmed === "Çerez Politikası ve Aydınlatma Metni" ||
                          trimmed === "Çerez Politikası" ||
                          trimmed === "Çerez Politikası ve Bilgilendirme";

                        const isSubTitle =
                          trimmed === "Kalıcı Çerezler" ||
                          trimmed === "Zorunlu Çerezler" ||
                          trimmed === "Performans Çerezleri" ||
                          trimmed === "Fonksiyonellik Çerezleri" ||
                          trimmed === "Hedef veya Reklam Çerezleri" ||
                          trimmed === "Birinci Taraf Çerezleri" ||
                          trimmed === "Üçüncü Taraf Çerezleri" ||
                          trimmed === "Ekşioğlu Hukuk & Danışmanlık" ||
                          trimmed === "Veri Sorumlusu";

                        const isSectionTitle =
                          /^\d+\.\s+/.test(trimmed) ||
                          /^[a-zA-Z]\)\s+/.test(trimmed) ||
                          trimmed.endsWith("?") ||
                          isSubTitle;

                        const isBullet =
                          trimmed.startsWith("•") ||
                          trimmed.startsWith("-") ||
                          trimmed.startsWith("–") ||
                          trimmed.startsWith("—");

                        const bulletText = isBullet
                          ? trimmed.replace(/^(•|-|–|—)\s*/, "")
                          : "";

                        // ====== RENDER ======
                        if (isBullet) {
                          return (
                            <div
                              key={idx}
                              style={{
                                display: "flex",
                                gap: 10,
                                alignItems: "flex-start",
                                marginBottom: 8,
                              }}
                            >
                              <span
                                aria-hidden="true"
                                style={{
                                  width: 18,
                                  lineHeight: "20px",
                                  fontSize: 16,
                                  fontWeight: 900,
                                  color: "#0ea5e9",
                                }}
                              >
                                •
                              </span>

                              <p
                                style={{
                                  margin: 0,
                                  color: "#0f172a",
                                  lineHeight: 1.7,
                                  fontSize: 14,
                                }}
                              >
                                {bulletText}
                              </p>
                            </div>
                          );
                        }

                        const textNode =
                          isMainTitle || isSectionTitle ? (
                            <strong>{trimmed}</strong>
                          ) : (
                            trimmed
                          );

                        return (
                          <p
                            key={idx}
                            style={{
                              marginBottom: isMainTitle ? 14 : 10,
                              marginTop: isMainTitle
                                ? 6
                                : isSectionTitle
                                  ? 18
                                  : 0,
                              fontSize: isMainTitle
                                ? 18
                                : isSectionTitle
                                  ? 15
                                  : 14,
                              color: isMainTitle
                                ? "#0f172a"
                                : isSectionTitle
                                  ? "#0f172a"
                                  : "#334155",
                              lineHeight: 1.75,
                            }}
                          >
                            {textNode}
                          </p>
                        );
                      })}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default CerezPolitikasi;
